import React, { useContext, useEffect, useState } from 'react'
import "./paymentStatus.css"
import "../checkout-page/checkOutPage.css"
import { LoadingSpinner } from '../../components/mini-components/mini-components'
import Lottie from "lottie-react";
import failed from "../../assets/lottie/failed.json";
import success from "../../assets/lottie/success.json";
import { useLocation, useNavigate } from 'react-router-dom';
import { successToast , errorToast } from '../../functions/mini_func';
import CartContext from '../../context/cart_context';
import { ref , get , off , onValue   } from 'firebase/database';
import { db } from '../../config/firebase_config';

const PaymentStatus = () => {

    const [payStatus, setpayStatus] = useState(null);
    const [startLoading, setStartLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('orderId');

    const {resetCart } = useContext(CartContext);


    const retriveOrderData = () => {
        setStartLoading(true);
        const userData = JSON.parse(localStorage.getItem("user"));
        const dabaseRef = ref(db , `TrackPayments/${userData.phoneNo}/${orderId}` );
        get(dabaseRef).then(
           async (snapshot) => {
              console.log(snapshot);
                const data = snapshot.val();
                console.log(data);
                const orderRef = ref(db, `TrackPayments/${userData.phoneNo}/${orderId}`);
                 if(data.status == "TXN_SUCCESS" ){
                    setStartLoading(false);
                    navigate(`/orderpage?orderID=${data.dbID}`,{replace:true});
                    resetCart();
                    localStorage.removeItem("paytm");
                    localStorage.removeItem("razorOrderId");
                 }else if(data.status == "TXN_FAILURE"){
                    setStartLoading(false);
                    errorToast("Transaction failed" , "Payment failed or dismissed . please try again" );
                    localStorage.removeItem("razorOrderId");
                    localStorage.removeItem("paytm");
                 }else if(data.status == "init"){
                    const listeningDurationInMilliseconds = 5 * 60 * 1000;
                    const currentTime = Date.now();
                    const timeDifferenceInSeconds = Math.floor((currentTime - parseFloat(orderId)) / 1000);
                
                  if (timeDifferenceInSeconds < 300) {
                    const timer = setTimeout(() => {
                      const listener = onValue(orderRef, async(snapshot) => {

                        const data = snapshot.val();
                        if (data && data.status === "TXN_SUCCESS") {
                          navigate(`/orderpage?orderID=${data.dbID}`,{replace:true});
                          resetCart();
                          setStartLoading(false);
                          localStorage.removeItem("razorOrderId");
                          localStorage.removeItem("paytm");

                        } else if ( data && data.status === "TXN_FAILURE") {

                          errorToast("Transaction failed", "Payment failed or dismissed. Please try again");
                          localStorage.removeItem("razorOrderId");
                          localStorage.removeItem("paytm");
                          setStartLoading(false);
                          // remove(orderRef);
                        }
                        console.log(data);
                        if(listener != null){
                          off(orderRef, 'value', listener);
                        }
                        clearTimeout(timer);
                        // remove(orderRef);
                      });
    
                      setTimeout(() => {
                        if(listener != null){
                          off(orderRef, 'value', listener);
                        }
                      }, listeningDurationInMilliseconds - (timeDifferenceInSeconds));
    
    
                    }, listeningDurationInMilliseconds - (timeDifferenceInSeconds));
                    
                  }else{
                    localStorage.removeItem("razorOrderId");
                    localStorage.removeItem("paytm");
                    // remove(orderRef);
                    setStartLoading(false);
                  }
                  
                 }else{
                  localStorage.removeItem("razorOrderId");
                  localStorage.removeItem("paytm");
                  // remove(orderRef);
                  setStartLoading(false);
                 }
            } 
        ).catch((e) => {
              console.log(e);
        });
      }

    useEffect(() => {
      const fetchData = async() => {
        const response = await fetch(`https://us-central1-thediningapp-a976c.cloudfunctions.net/paytmTransaction?orderId=${orderId}`);
        const data = await response.json();
        if(data.status == "TXN_SUCCESS"){
            successToast("Transaction Succesful" , "Payment completed Succesfully . please wait while we are checking order Status");
            retriveOrderData();
        
        }
        setpayStatus(data);
      }

      fetchData();
     
    }, [])
    
  return (
    <div className='status-container'>
        { 
         payStatus  ? 
         <>
             <Lottie animationData={ payStatus.status == "TXN_SUCCESS" ? success : failed}  className="failed-lottie"  />
             <h3 className="process-heading">{ payStatus.status == "TXN_SUCCESS" ?  "Transaction Succesful"  :  "Payment Failed"}</h3>
             {
                payStatus.amount &&  <h2>{"\u{20B9}\t"}{payStatus.amount}</h2>
             }
              {
                <p className='trns-data'> OrderID : {orderId}</p>
             }
             {
               payStatus.status != "TXN_SUCCESS" &&  <p className='trns-data'>{payStatus.msg}</p>
             }
             {
                payStatus.txnId &&    <p  style={{fontSize : "12px"}} className='trns-data'>Transaction ID : { payStatus.txnId}</p>
             }
             {
                payStatus.date &&  <p className='trns-data'> Date : {payStatus.date.split(" ")[0]}</p>
             }
             {
                 payStatus.date &&  <p className='trns-data'>Time : { payStatus.date.split(" ")[1]}</p>
             }
            {
               payStatus != "TXN_SUCCESS" && <button className = "back-btn" onClick={() =>  navigate(-1 ) } >Go Back</button>
            }
             {
          startLoading && 
          (
            <div className='checkout-loading-bg' >
                <div className='checkout-loading'>
                  <LoadingSpinner/>
                </div>
             </div>
          )
        }
         </>
        :
            <>
              <LoadingSpinner isBig={true}/>
                <h4 className='process-heading'>Processing payment information ....</h4>
                <span className='process-sub'> please wait for a while we are verifying payment status</span>
            </>
        }
    </div>
  )

}

export default PaymentStatus
